/**
 * Maps icon name strings from storyboard JSON → Lucide React components.
 * Usage in componentProps: { "icon": "Sparkles" }
 * Usage in code: const Icon = getIcon('Sparkles');
 */
import type { LucideIcon } from 'lucide-react';
import {
  Sparkles, TrendingUp, TrendingDown, Users, Brain, Database,
  BarChart3, FileText, Mail, Search, MapPin, Globe,
  MessageSquare, Zap, Shield, CheckCircle, ArrowRight,
  ExternalLink, Bot, Crown, Megaphone, Newspaper,
  Upload, Eye, Heart, Star, Target, Lightbulb,
  Mic, Video, PenTool, Send, Layers, Activity,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  Sparkles, TrendingUp, TrendingDown, Users, Brain, Database,
  BarChart3, FileText, Mail, Search, MapPin, Globe,
  MessageSquare, Zap, Shield, CheckCircle, ArrowRight,
  ExternalLink, Bot, Crown, Megaphone, Newspaper,
  Upload, Eye, Heart, Star, Target, Lightbulb,
  Mic, Video, PenTool, Send, Layers, Activity,
};

/** Look up a Lucide icon by name. Returns null if not found. */
export const getIcon = (name?: string): LucideIcon | null => {
  if (!name) return null;
  return ICON_MAP[name] || null;
};

/** List all available icon names. */
export const getAvailableIcons = (): string[] => Object.keys(ICON_MAP);
